function getTableData(data, reportType) {
  // param: data list of: [
  //   {
  //     "id": 32869,
  //     "ip": "181.112.9.70",
  //     "user": "admin@aensaecuador.org",
  //     "date": 1535509588590,
  //     "reportType": 229,
  //     "reportParams": "{\"tipoReporte\":null,\"nivelDetalle\":null,\"molecularCompound\":null,\"tipoDatos\":null,\"periodo\":null,\"productName\":null,\"sectorId\":null,\"groupId\":null,\"subsectorId\":null,\"categoryId\":null,\"year\":2018}"
  // }]

  var rows = [];
  data.forEach((elem, index) => {
    var dateObj = new Date(elem.date);
    var _temp = {
      Nro: index + 1,
      ip: elem.ip,
      user: elem.user,
      date: dateObj.toISOString(),
      reportType: reportType.filter((e) => e.id === elem.reportType)[0].name,
    };
    rows.push(_temp);
  });

  // return values in a format that charts components understand
  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "5%" },
      { Header: "Ip", accessor: "ip" },
      { Header: "User", accessor: "user" },
      { Header: "Fecha", accessor: "date" },
      { Header: "Tipo de Reporte", accessor: "reportType" },
    ],
    rows: rows,
  };
}

export default getTableData;
